import { Outlet, useParams } from "react-router-dom";
import { useState } from "react";

// global
import { projectStore } from "../../store/Store";

// components
import AddVendorInvoice from "./AddVendorInvoice";
import AddSandInvoice from "./AddSandInvoice";
import VendorInvoiceTabs from "./VendorInvoiceTabs";
import AddAssetInvoice from "./AddAssetInvoice";
import Loading from "../../components/Loading";
import ErrorDisplay from "../../components/ErrorDisplay";

// hooks
import useGetFetch from "../../hooks/useGetFetch";
import GenerateVendorInvoice from "./GenerateVendorInvoice";

export default function VendorInvoices() {
  // global
  const setCurrentProject = projectStore((data) => data.setCurrentProject);
  const setProjectLoads = projectStore((data) => data.setProjectLoads);
  const setProjectAssetLoads = projectStore(
    (data) => data.setProjectAssetLoads,
  );
  const setProjectCarriers = projectStore((data) => data.setProjectCarriers);
  const setProjectVendorInvoiceTotals = projectStore(
    (data) => data.setProjectVendorInvoiceTotals,
  );
  const setProjectSandRates = projectStore((data) => data.setProjectSandRates);
  const setProjectCustomerInvoices = projectStore(
    (data) => data.setProjectCustomerInvoices,
  );

  // local
  const [triggerFreightInvoice, setTriggerFreightInvoice] = useState(false);
  const [triggerSandInvoice, setTriggerSandInvoice] = useState(false);
  const [triggerAssetInvoice, setTriggerAssetInvoice] = useState(false);
  const [triggerGenerateFreight, setTriggerGenerateFreight] = useState(false);
  const [triggerGenerateAsset, setTriggerGenerateAsset] = useState(false);
  const [invoiceType, setInvoiceType] = useState("Freight");

  const { invId } = useParams("invId");
  const { id } = useParams("id");

  const { isPending: projectPending, error: projectError } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/project/${id}`,
    setCurrentProject,
  );
  const { isPending: loadsPending, error: loadsError } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/loads/${id}`,
    setProjectLoads,
  );
  const { isPending: assetLoadsPending, error: assetLoadsError } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/asset-loads/${id}`,
    setProjectAssetLoads,
  );
  const { isPending: carriersPending, error: carriersError } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/project/carriers/${id}`,
    setProjectCarriers,
  );
  const { isPending: invoiceTotalsPending, error: invoiceTotalsError } =
    useGetFetch(
      `${process.env.REACT_APP_BACKEND}/pc/vendor-invoices-totals/${id}`,
      setProjectVendorInvoiceTotals,
    );
  const { isPending: sandRatesPending, error: sandRatesError } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/sand-rates/${id}`,
    setProjectSandRates,
  );
  const { isPending, error } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/customer-invoices/${id}`,
    setProjectCustomerInvoices,
  );

  if (
    projectPending ||
    assetLoadsPending ||
    carriersPending ||
    invoiceTotalsPending ||
    isPending ||
    sandRatesPending ||
    loadsPending
  ) {
    return <Loading />;
  }
  if (
    projectError ||
    loadsError ||
    assetLoadsError ||
    carriersError ||
    invoiceTotalsError ||
    sandRatesError ||
    error
  ) {
    return <ErrorDisplay message={"Something Went Wrong"} code={500} />;
  }
  return (
    <div className="container-fluid">
      {!invId && (
        <div className="d-flex justify-content-between dashboard-header border-bottom">
          <h4>Vendor Invoices</h4>
        </div>
      )}
      {!invId && (
        <VendorInvoiceTabs
          setTriggerFreightInvoice={setTriggerFreightInvoice}
          setTriggerSandInvoice={setTriggerSandInvoice}
          setTriggerAssetInvoice={setTriggerAssetInvoice}
          setTriggerGenerateFreight={setTriggerGenerateFreight}
          setTriggerGenerateAsset={setTriggerGenerateAsset}
          invoiceType={invoiceType}
          setInvoiceType={setInvoiceType}
        />
      )}

      <Outlet context={{ invoiceType }} />
      {triggerFreightInvoice && (
        <AddVendorInvoice setTriggerInvoice={setTriggerFreightInvoice} />
      )}
      {triggerSandInvoice && (
        <AddSandInvoice setTriggerInvoice={setTriggerSandInvoice} />
      )}
      {triggerAssetInvoice && (
        <AddAssetInvoice setTriggerInvoice={setTriggerAssetInvoice} />
      )}
      {triggerGenerateFreight && (
        <GenerateVendorInvoice
          setTriggerInvoice={setTriggerGenerateFreight}
          isAsset={false}
        />
      )}
      {triggerGenerateAsset && (
        <GenerateVendorInvoice
          setTriggerInvoice={setTriggerGenerateAsset}
          isAsset={true}
        />
      )}
    </div>
  );
}
